unit PayTerms;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.Buttons, XData.Web.Client, Data.DB, WEBLib.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, Vcl.Controls, WEBLib.ExtCtrls;

type
  TfrmPayType = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    dgPayTerms: TTMSFNCDataGrid;
    dgdbaPayTerms: TTMSFNCDataGridDatabaseAdapter;
    wdsPayTerms: TXDataWebDataSet;
    dsPayTerms: TDataSource;
    wcPayTerms: TXDataWebClient;
    WebButton1: TButton;
    WebButton2: TButton;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    edtPayTermsPC: TEdit;
    wdsPayTermsAutoNo: TIntegerField;
    wdsPayTermsDescription: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure dgPayTermsCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
  private
    { Private declarations }
    iPayTermsPC , iPayTermsMaxPC : Integer;


    procedure LoadPayTerms;
  public
    { Public declarations }
    iPayTermsAutoNo : Integer;
    sPayTermsDescription : String;
  protected procedure LoadDFMValues; override; end;

var
  frmPayType: TfrmPayType;

implementation

{$R *.dfm}
uses
  stfmssystem.connection;

{ TfrmPayType }

procedure TfrmPayType.dgPayTermsCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  dgdbaPayTerms.SetActiveRecord(ARow);

  iPayTermsPC := dgdbaPayTerms.FieldAtColumn[0].AsInteger;
  sPayTermsDescription := dgdbaPayTerms.FieldAtColumn[1].AsString;
end;

procedure TfrmPayType.LoadPayTerms;
var
  sJsonParams : String;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);

    end;

  procedure OnResult(Response : TXDataClientResponse);
    begin
      wdsPayTerms.Close;
      wdsPayTerms.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsPayTerms.Open;

      edtPayTermsPC.Text := IntToStr(iPayTermsPC) + ' of ' + IntToStr(iPayTermsMaxPC);
    end;

  procedure OnResultPC(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadPayTerms;
        end
      else
        begin
          iPayTermsMaxPC := Integer(TJSObject(Response.Result)['value']);

          sJsonParams := '{"PageCount":' + IntToStr(iPayTermsPC) + '}';

          wcPayTerms.RawInvoke('IstfmsloadsService.Get_PayTerms_View',[sJsonParams],@OnResult,@OnError);
        end;
    end;


begin
  wcPayTerms.RawInvoke('IstfmsloadsService.Get_PayTerms_MaxPC',[],@OnResultPC,@OnError);
end;

procedure TfrmPayType.WebButton1Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmPayType.WebButton2Click(Sender: TObject);
begin
  iPayTermsAutoNo := -1;
  sPayTermsDescription := '';
  close;
end;

procedure TfrmPayType.WebFormShow(Sender: TObject);
begin
  iPayTermsPC := 1;
  LoadPayTerms;
end;

procedure TfrmPayType.WebSpeedButton1Click(Sender: TObject);
begin
  iPayTermsPC := 1;
  LoadPayTerms;
end;

procedure TfrmPayType.WebSpeedButton2Click(Sender: TObject);
begin
  if iPayTermsPC > 1 then
    Begin
      iPayTermsPC := iPayTermsPC - 1;

      LoadPayTerms;
    End;

end;

procedure TfrmPayType.WebSpeedButton3Click(Sender: TObject);
begin
  if iPayTermsPC < iPayTermsMaxPC then
    Begin
      iPayTermsPC := iPayTermsPC + 1;

      LoadPayTerms;
    End;
end;

procedure TfrmPayType.WebSpeedButton4Click(Sender: TObject);
begin
  iPayTermsPC := iPayTermsMaxPC;
  LoadPayTerms;
end;

procedure TfrmPayType.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  edtPayTermsPC := TEdit.Create(Self);
  dgPayTerms := TTMSFNCDataGrid.Create(Self);
  dgdbaPayTerms := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wdsPayTerms := TXDataWebDataSet.Create(Self);
  wdsPayTermsAutoNo := TIntegerField.Create(Self);
  wdsPayTermsDescription := TStringField.Create(Self);
  dsPayTerms := TDataSource.Create(Self);
  wcPayTerms := TXDataWebClient.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  edtPayTermsPC.BeforeLoadDFMValues;
  dgPayTerms.BeforeLoadDFMValues;
  dgdbaPayTerms.BeforeLoadDFMValues;
  wdsPayTerms.BeforeLoadDFMValues;
  wdsPayTermsAutoNo.BeforeLoadDFMValues;
  wdsPayTermsDescription.BeforeLoadDFMValues;
  dsPayTerms.BeforeLoadDFMValues;
  wcPayTerms.BeforeLoadDFMValues;
  try
    Name := 'frmPayType';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 480;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 640;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Pay Terms';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 420;
    WebPanel3.Width := 640;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 24;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Select';
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 152;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Close';
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebSpeedButton1.SetParentComponent(WebPanel3);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 296;
    WebSpeedButton1.Top := 16;
    WebSpeedButton1.Width := 24;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 2;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton2.SetParentComponent(WebPanel3);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 326;
    WebSpeedButton2.Top := 16;
    WebSpeedButton2.Width := 24;
    WebSpeedButton2.Height := 24;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 3;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton3.SetParentComponent(WebPanel3);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 408;
    WebSpeedButton3.Top := 16;
    WebSpeedButton3.Width := 24;
    WebSpeedButton3.Height := 24;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 4;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebSpeedButton4.SetParentComponent(WebPanel3);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 448;
    WebSpeedButton4.Top := 16;
    WebSpeedButton4.Width := 24;
    WebSpeedButton4.Height := 24;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 5;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    edtPayTermsPC.SetParentComponent(WebPanel3);
    edtPayTermsPC.Name := 'edtPayTermsPC';
    edtPayTermsPC.Left := 360;
    edtPayTermsPC.Top := 16;
    edtPayTermsPC.Width := 42;
    edtPayTermsPC.Height := 22;
    edtPayTermsPC.ChildOrder := 6;
    edtPayTermsPC.HeightPercent := 100.000000000000000000;
    edtPayTermsPC.Text := '0 of 0';
    edtPayTermsPC.WidthPercent := 100.000000000000000000;
    dgPayTerms.SetParentComponent(WebPanel1);
    dgPayTerms.Name := 'dgPayTerms';
    dgPayTerms.Left := 0;
    dgPayTerms.Top := 60;
    dgPayTerms.Width := 640;
    dgPayTerms.Height := 360;
    dgPayTerms.Align := alClient;
    dgPayTerms.ParentDoubleBuffered := False;
    dgPayTerms.DoubleBuffered := True;
    dgPayTerms.TabOrder := 2;
    dgPayTerms.ShowAcceleratorChar := False;
    dgPayTerms.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    dgPayTerms.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    dgPayTerms.Header.VisualGrouping.Layout.Font.Height := -12;
    dgPayTerms.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    dgPayTerms.Header.VisualGrouping.Layout.Font.Style := [];
    dgPayTerms.Adapter := dgdbaPayTerms;
    dgPayTerms.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgPayTerms.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    dgPayTerms.CellAppearance.FilterMatchLayout.Font.Height := -12;
    dgPayTerms.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    dgPayTerms.CellAppearance.FilterMatchLayout.Font.Style := [];
    dgPayTerms.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    dgPayTerms.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    dgPayTerms.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    dgPayTerms.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    dgPayTerms.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    dgPayTerms.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    dgPayTerms.CellAppearance.BandLayout.Font.Color := clWindowText;
    dgPayTerms.CellAppearance.BandLayout.Font.Height := -12;
    dgPayTerms.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    dgPayTerms.CellAppearance.BandLayout.Font.Style := [];
    dgPayTerms.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    dgPayTerms.CellAppearance.FixedLayout.Font.Color := clWindowText;
    dgPayTerms.CellAppearance.FixedLayout.Font.Height := -12;
    dgPayTerms.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    dgPayTerms.CellAppearance.FixedLayout.Font.Style := [];
    dgPayTerms.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgPayTerms.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    dgPayTerms.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    dgPayTerms.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    dgPayTerms.CellAppearance.FixedSelectedLayout.Font.Style := [];
    dgPayTerms.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    dgPayTerms.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    dgPayTerms.CellAppearance.FocusedLayout.Font.Height := -12;
    dgPayTerms.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    dgPayTerms.CellAppearance.FocusedLayout.Font.Style := [];
    dgPayTerms.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    dgPayTerms.CellAppearance.GroupLayout.Font.Color := clWindowText;
    dgPayTerms.CellAppearance.GroupLayout.Font.Height := -12;
    dgPayTerms.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    dgPayTerms.CellAppearance.GroupLayout.Font.Style := [];
    dgPayTerms.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    dgPayTerms.CellAppearance.NormalLayout.Font.Color := clWindowText;
    dgPayTerms.CellAppearance.NormalLayout.Font.Height := -12;
    dgPayTerms.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    dgPayTerms.CellAppearance.NormalLayout.Font.Style := [];
    dgPayTerms.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    dgPayTerms.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    dgPayTerms.CellAppearance.SelectedLayout.Font.Height := -12;
    dgPayTerms.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    dgPayTerms.CellAppearance.SelectedLayout.Font.Style := [];
    dgPayTerms.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    dgPayTerms.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    dgPayTerms.CellAppearance.SummaryLayout.Font.Height := -12;
    dgPayTerms.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    dgPayTerms.CellAppearance.SummaryLayout.Font.Style := [];
    dgPayTerms.ColumnCount := 2;
    dgPayTerms.Columns.Clear;
    with dgPayTerms.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'AutoNo';
    end;
    with dgPayTerms.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Description';
    end;
    dgPayTerms.Designer := False;
    dgPayTerms.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    dgPayTerms.FilterAppearance.Font.Color := clWindowText;
    dgPayTerms.FilterAppearance.Font.Height := -12;
    dgPayTerms.FilterAppearance.Font.Name := 'Segoe UI';
    dgPayTerms.FilterAppearance.Font.Style := [];
    dgPayTerms.Icons.ExpandIcon.LoadFromFile('PayTerms.WebPanel1.dgPayTerms.Icons.ExpandIcon.svg');
    dgPayTerms.Icons.CollapseIcon.LoadFromFile('PayTerms.WebPanel1.dgPayTerms.Icons.CollapseIcon.svg');
    dgPayTerms.Icons.FilterIcon.LoadFromFile('PayTerms.WebPanel1.dgPayTerms.Icons.FilterIcon.svg');
    dgPayTerms.Icons.FilterActiveIcon.LoadFromFile('PayTerms.WebPanel1.dgPayTerms.Icons.FilterActiveIcon.svg');
    dgPayTerms.Icons.FilterClearIcon.LoadFromFile('PayTerms.WebPanel1.dgPayTerms.Icons.FilterClearIcon.svg');
    dgPayTerms.Icons.FilterTypeIcon.LoadFromFile('PayTerms.WebPanel1.dgPayTerms.Icons.FilterTypeIcon.svg');
    dgPayTerms.Icons.SortAscendingIcon.LoadFromFile('PayTerms.WebPanel1.dgPayTerms.Icons.SortAscendingIcon.svg');
    dgPayTerms.Icons.SortDescendingIcon.LoadFromFile('PayTerms.WebPanel1.dgPayTerms.Icons.SortDescendingIcon.svg');
    dgPayTerms.Icons.CloseIcon.LoadFromFile('PayTerms.WebPanel1.dgPayTerms.Icons.CloseIcon.svg');
    SetEvent(dgPayTerms, Self, 'OnCellClick', 'dgPayTermsCellClick');
    dgPayTerms.RowCount := 1;
    dgdbaPayTerms.SetParentComponent(dgPayTerms);
    dgdbaPayTerms.Name := 'dgdbaPayTerms';
    dgdbaPayTerms.Left := 326;
    dgdbaPayTerms.Top := 96;
    dgdbaPayTerms.Width := 26;
    dgdbaPayTerms.Height := 26;
    dgdbaPayTerms.Visible := True;
    dgdbaPayTerms.Columns.Clear;
    with dgdbaPayTerms.Columns.Add do
    begin
      FieldName := 'AutoNo';
      Header := 'AutoNo';
      AutoCreated := False;
    end;
    with dgdbaPayTerms.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Description';
      AutoCreated := False;
    end;
    dgdbaPayTerms.DataSource := dsPayTerms;
    wdsPayTerms.SetParentComponent(Self);
    wdsPayTerms.Name := 'wdsPayTerms';
    wdsPayTerms.Connection := dmData.dbConnect;
    wdsPayTerms.Left := 160;
    wdsPayTerms.Top := 156;
    wdsPayTermsAutoNo.SetParentComponent(wdsPayTerms);
    wdsPayTermsAutoNo.Name := 'wdsPayTermsAutoNo';
    wdsPayTermsAutoNo.FieldName := 'AutoNo';
    wdsPayTermsDescription.SetParentComponent(wdsPayTerms);
    wdsPayTermsDescription.Name := 'wdsPayTermsDescription';
    wdsPayTermsDescription.FieldName := 'Description';
    dsPayTerms.SetParentComponent(Self);
    dsPayTerms.Name := 'dsPayTerms';
    dsPayTerms.DataSet := wdsPayTerms;
    dsPayTerms.Left := 216;
    dsPayTerms.Top := 156;
    wcPayTerms.SetParentComponent(Self);
    wcPayTerms.Name := 'wcPayTerms';
    wcPayTerms.Connection := dmData.dbConnect;
    wcPayTerms.Left := 104;
    wcPayTerms.Top := 156;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    edtPayTermsPC.AfterLoadDFMValues;
    dgPayTerms.AfterLoadDFMValues;
    dgdbaPayTerms.AfterLoadDFMValues;
    wdsPayTerms.AfterLoadDFMValues;
    wdsPayTermsAutoNo.AfterLoadDFMValues;
    wdsPayTermsDescription.AfterLoadDFMValues;
    dsPayTerms.AfterLoadDFMValues;
    wcPayTerms.AfterLoadDFMValues;
  end;
end;

end.